/**
 * @Author: ZLZ
 * @Date: 2025-11-05 18:18:00
 * @LastEditors: ZLZ
 * @LastEditTime: 2025-11-05 18:18:00
 * @Description: 2.0 内容 寻龙诀 路由模块
 * @FilePath: \qs\src\router\modules\xunLongJue.js
 */
import Layout from "@/Layout";
export default [
  {
    path: "/xieTongQinNiu",
    component: Layout,
    name: "XieTongQinNiu",
    redirect: "/xieTongQinNiu/index",
    children: [
      {
        path: "index",
        component: () => import("@/views/xieTongQinNiu/index.vue"),
        meta: {
          title: "协同擒牛",
          keepAlive: false,
          showFooter: false,
          showHead: true,
          showLeft: true,
          showRight: false
        }
      },
      {
        path: 'detail',
        component: () => import("@/views/xieTongQinNiu/detail.vue"),
        meta: {
          title: "选股结果",
          keepAlive: false,
          showFooter: false,
          showHead: true,
          showLeft: true,
          showRight: false
        }
      },
    ],
  },
];
